import type { FC } from 'react';

import { GlobeIcon, GlobeSimpleIcon } from '@phosphor-icons/react';
import styled, { css, useTheme } from 'styled-components';

import { media } from '../../core/styles';
import { Typography } from '../../core/typography/Typography';
import { useAppContext } from '~/utilities/context/static/AppContext';
import { SiteType } from '~/utilities/graphql/codegen';

const S = {
  Language: styled(Typography)`
    ${({ theme }) => css`
      line-height: var(--top-nav-height);
      font-weight: ${theme.variables.font.weight.bold};
      text-transform: uppercase;

      @media ${media(theme).lessThan('sm')} {
        padding-right: ${theme.padding.sm};
      }
    `}
  `,
};

type Props = {
  language: string;
};

const LocaleText = ({ language }: Props) => (
  <S.Language component="span" variant="title" testId="locale-selector-language">
    {language}
  </S.Language>
);

const LocaleGlobeIcon = () => {
  const theme = useTheme();

  return <GlobeIcon size={theme.components.icon.topNavigation.size} />;
};

const LocaleGlobeSimpleIcon = () => {
  const theme = useTheme();

  return <GlobeSimpleIcon size={theme.components.icon.topNavigation.size} />;
};

const LocaleSelectorIconMap: Record<SiteType, FC<Props>> = {
  [SiteType.Aaf]: LocaleGlobeIcon,
  [SiteType.Employeeshop]: LocaleText,
  [SiteType.Gstar]: LocaleText,
  [SiteType.Outlet]: LocaleText,
  [SiteType.Wahts]: LocaleGlobeSimpleIcon,
};

export function LocaleSelectorIcon({ language }: Props) {
  const { siteType } = useAppContext();
  const IconComponent = LocaleSelectorIconMap[siteType];

  return <IconComponent language={language} />;
}
